<template>
  <div :class="$style.file">
    <a :href="file.file" target="_blank">{{ file.name }}</a>
    <img
      :class="{ [$style.readonly]: readonly }"
      @click="
        $store.dispatch('deleteFile', { id: file.id, route: $route.name })
      "
      src="/icons/white-cross.svg"
      alt=""
    />
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      defaul: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module>
.file {
  padding: 0.75rem;
  display: flex;
  align-items: center;
  width: 11.5rem;
  background-color: $t-secondary;
  border-radius: 0.25rem;
  gap: 0.5rem;
  color: $t-white;
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @include Body2;
    flex: 1 1 auto;
  }
  img {
    flex: 0 0 1rem;
    cursor: pointer;
    &.readonly {
      pointer-events: none;
    }
  }
}
</style>
